import React from "react";
import DashboardContainer from "components/Dashboard/DashboardContainer";
import { useAppMeta } from "hooks";
import { AnalyticOverview } from "components/Dashboard/AnalyticOverview";
import { useGetDashboardStatsQuery, useGetDashboardPriceStatsQuery } from "store/services/dashboardApi";
import DashboardHeading from "components/Dashboard/DashboardHeading";
import { Box } from "@mui/material";
import moment from "moment";

const CRMDashboardScreen = () => {
  // Calculate date range for last 7 days (for ShipmentLineResult and DeliveryLineResult)
  const today = new Date();
  const sevenDaysAgo = new Date(today);
  sevenDaysAgo.setDate(today.getDate() - 6);
  const formattedFrom = moment(sevenDaysAgo).format("YYYY-MM-DD");
  const formattedTo = moment(today).format("YYYY-MM-DD");

  const {
    data: fetchStatsData,
    isLoading: statsDataLoading,
    isFetching: fetchingDashboard,
    refetch: refetchStats,
  } = useGetDashboardStatsQuery(
    { fromDate: formattedFrom, toDate: formattedTo },
    {
      pollingInterval: 60000,
    }
  );

  const {
    isFetching: fetchingPriceStats,
    refetch: refetchPriceStats,
  } = useGetDashboardPriceStatsQuery(
    { fromDate: formattedFrom, toDate: formattedTo },
    {
      pollingInterval: 60000,
    }
  );

  useAppMeta("Dashboard");

  return (
    <DashboardContainer>
      <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={1} mb={2}>
        <DashboardHeading />
      </Box>
      <AnalyticOverview
        statsData={fetchStatsData}
        isLoading={statsDataLoading}
        refetchStats={refetchStats}
        refetchPriceStats={refetchPriceStats}
        isFetching={fetchingDashboard || fetchingPriceStats}
      />
    </DashboardContainer>
  );
};

export default CRMDashboardScreen;